import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Settings, Link2, CheckCircle } from "lucide-react";

export function AccountingIntegrationSettings() {
  // Mock integration status
  const integrations = [
    { name: "QuickBooks", connected: true, lastSync: "2 hours ago" },
    { name: "Xero", connected: false, lastSync: null },
    { name: "Sage", connected: false, lastSync: null },
    { name: "NetSuite", connected: false, lastSync: null },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="h-5 w-5" />
          Accounting System Integrations
        </CardTitle>
        <CardDescription>
          Connect and configure integrations with your accounting systems
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {integrations.map((integration) => (
          <Card key={integration.name}>
            <CardContent className="flex items-center justify-between p-4">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${integration.connected ? "bg-green-500/10" : "bg-muted"}`}>
                  {integration.connected ? (
                    <CheckCircle className="h-5 w-5 text-green-500" />
                  ) : (
                    <Link2 className="h-5 w-5 text-muted-foreground" />
                  )}
                </div>
                <div>
                  <p className="font-medium">{integration.name}</p>
                  {integration.connected && integration.lastSync && (
                    <p className="text-xs text-muted-foreground">
                      Last synced: {integration.lastSync}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Badge variant={integration.connected ? "outline" : "secondary"} className={integration.connected ? "border-green-500 text-green-500" : ""}>
                  {integration.connected ? "Connected" : "Not Connected"}
                </Badge>
                <Button size="sm" variant={integration.connected ? "outline" : "default"}>
                  {integration.connected ? "Configure" : "Connect"}
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}

        <Card className="bg-muted/30">
          <CardContent className="p-4 space-y-3">
            <div className="flex items-center justify-between">
              <div className="space-y-0.5">
                <Label>Auto-Sync Enabled</Label>
                <p className="text-xs text-muted-foreground">
                  Automatically sync payments every hour
                </p>
              </div>
              <Switch defaultChecked />
            </div>
            <div className="flex items-center justify-between">
              <div className="space-y-0.5">
                <Label>Two-Way Sync</Label>
                <p className="text-xs text-muted-foreground">
                  Sync changes bidirectionally
                </p>
              </div>
              <Switch />
            </div>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
}
